import * as Yup from 'yup';

import { createLocale } from 'locales';

const globalLocalize = createLocale('global');

export default Yup.object().shape({
  email: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .email(globalLocalize('emailInvalidErrorMessage')),
  first_name: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .max(100, globalLocalize('maxLengthFieldError', { count: '100' })),
  last_name: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .max(100, globalLocalize('maxLengthFieldError', { count: '100' })),
  password1: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .min(8, globalLocalize('minLengthPasswordErrorMessage'))
    .matches(
      /((?=.*[a-zA-Z]){1})/,
      globalLocalize('PasswordConstraintErrorMessage'),
    )
    .matches(/\d+/, globalLocalize('PasswordConstraintErrorMessage')),
  password2: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .oneOf(
      [Yup.ref('password1'), null],
      globalLocalize('passwordsMustMatchErrorMessage'),
    ),
  termsAndConditions: Yup.bool().oneOf([true], globalLocalize('mustAgree')),
  username: Yup.string()
    .required(globalLocalize('fieldRequiredErrorMessage'))
    .max(50, globalLocalize('maxLengthFieldError', { count: '50' })),
});
